import { render, staticRenderFns } from "./history_newAndOld_analysis.vue?vue&type=template&id=353df317&scoped=true"
import script from "./history_newAndOld_analysis.vue?vue&type=script&lang=js"
export * from "./history_newAndOld_analysis.vue?vue&type=script&lang=js"
import style0 from "./history_newAndOld_analysis.vue?vue&type=style&index=0&id=353df317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353df317",
  null
  
)

export default component.exports